import { Component, OnInit, Input } from '@angular/core';
import {FormGroup} from "@angular/forms";
import {MatDialog} from "@angular/material/dialog";
import {InfoDialogComponent} from "./dialog/infoDialog.component";

@Component({
    selector: 'app-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {
    matDialogRef: any;
    @Input() message = '';

    constructor(
        public _matDialog: MatDialog,
    ) {}

    ngOnInit() {}

    showInfoDialog() {
        this.matDialogRef = this._matDialog.open(InfoDialogComponent, {
            panelClass: 'info-dialog',
            data      : {
                action : 'show',
                message: this.message,
            },
            width: '450px',
        });

        this.matDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.matDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }
}
